// Languages supported by Deepgram Nova-3 (single-language mode), with the
// codes the API expects in `language=`. The "multi" code activates Nova-3's
// 10-language code-switching mode (EN/ES/FR/DE/HI/RU/PT/JA/IT/NL) and is
// useful when a single recording mixes two languages.
//
// `flag` is a Unicode flag emoji — keeps the UI image-free. `name` is the
// short Russian label rendered in the picker; `native` (optional) is the
// native spelling shown after a dash, helpful when the Russian name is
// ambiguous (e.g. "Каталанский — Català").
export const TRANSCRIPTION_LANGUAGES = [
  { code: 'multi', flag: '🌐', name: 'Авто', hint: 'RU+EN+8 языков, code-switching' },
  { code: 'ru',    flag: '🇷🇺', name: 'Русский' },
  { code: 'en',    flag: '🇬🇧', name: 'Английский', native: 'English' },
  { code: 'uk',    flag: '🇺🇦', name: 'Украинский', native: 'Українська' },
  { code: 'be',    flag: '🇧🇾', name: 'Белорусский', native: 'Беларуская' },
  { code: 'pl',    flag: '🇵🇱', name: 'Польский', native: 'Polski' },
  { code: 'cs',    flag: '🇨🇿', name: 'Чешский', native: 'Čeština' },
  { code: 'sk',    flag: '🇸🇰', name: 'Словацкий', native: 'Slovenčina' },
  { code: 'hu',    flag: '🇭🇺', name: 'Венгерский', native: 'Magyar' },
  { code: 'ro',    flag: '🇷🇴', name: 'Румынский', native: 'Română' },
  { code: 'bg',    flag: '🇧🇬', name: 'Болгарский', native: 'Български' },
  { code: 'sr',    flag: '🇷🇸', name: 'Сербский', native: 'Српски' },
  { code: 'hr',    flag: '🇭🇷', name: 'Хорватский', native: 'Hrvatski' },
  { code: 'bs',    flag: '🇧🇦', name: 'Боснийский', native: 'Bosanski' },
  { code: 'sl',    flag: '🇸🇮', name: 'Словенский', native: 'Slovenščina' },
  { code: 'mk',    flag: '🇲🇰', name: 'Македонский', native: 'Македонски' },
  { code: 'el',    flag: '🇬🇷', name: 'Греческий', native: 'Ελληνικά' },
  { code: 'tr',    flag: '🇹🇷', name: 'Турецкий', native: 'Türkçe' },
  { code: 'de',    flag: '🇩🇪', name: 'Немецкий', native: 'Deutsch' },
  { code: 'fr',    flag: '🇫🇷', name: 'Французский', native: 'Français' },
  { code: 'es',    flag: '🇪🇸', name: 'Испанский', native: 'Español' },
  { code: 'ca',    flag: '🇪🇸', name: 'Каталанский', native: 'Català' },
  { code: 'it',    flag: '🇮🇹', name: 'Итальянский', native: 'Italiano' },
  { code: 'pt',    flag: '🇵🇹', name: 'Португальский', native: 'Português' },
  { code: 'pt-BR', flag: '🇧🇷', name: 'Португальский (BR)', native: 'Português brasileiro' },
  { code: 'nl',    flag: '🇳🇱', name: 'Нидерландский', native: 'Nederlands' },
  { code: 'nl-BE', flag: '🇧🇪', name: 'Фламандский', native: 'Vlaams' },
  { code: 'da',    flag: '🇩🇰', name: 'Датский', native: 'Dansk' },
  { code: 'sv',    flag: '🇸🇪', name: 'Шведский', native: 'Svenska' },
  { code: 'no',    flag: '🇳🇴', name: 'Норвежский', native: 'Norsk' },
  { code: 'fi',    flag: '🇫🇮', name: 'Финский', native: 'Suomi' },
  { code: 'et',    flag: '🇪🇪', name: 'Эстонский', native: 'Eesti' },
  { code: 'lv',    flag: '🇱🇻', name: 'Латышский', native: 'Latviešu' },
  { code: 'lt',    flag: '🇱🇹', name: 'Литовский', native: 'Lietuvių' },
  { code: 'he',    flag: '🇮🇱', name: 'Иврит', native: 'עברית' },
  { code: 'ar',    flag: '🇸🇦', name: 'Арабский', native: 'العربية' },
  { code: 'fa',    flag: '🇮🇷', name: 'Персидский', native: 'فارسی' },
  { code: 'ur',    flag: '🇵🇰', name: 'Урду', native: 'اردو' },
  { code: 'hi',    flag: '🇮🇳', name: 'Хинди', native: 'हिन्दी' },
  { code: 'bn',    flag: '🇧🇩', name: 'Бенгальский', native: 'বাংলা' },
  { code: 'gu',    flag: '🇮🇳', name: 'Гуджарати', native: 'ગુજરાતી' },
  { code: 'kn',    flag: '🇮🇳', name: 'Каннада', native: 'ಕನ್ನಡ' },
  { code: 'mr',    flag: '🇮🇳', name: 'Маратхи', native: 'मराठी' },
  { code: 'ta',    flag: '🇮🇳', name: 'Тамильский', native: 'தமிழ்' },
  { code: 'te',    flag: '🇮🇳', name: 'Телугу', native: 'తెలుగు' },
  { code: 'zh',    flag: '🇨🇳', name: 'Китайский (упрощ.)', native: '简体中文' },
  { code: 'zh-TW', flag: '🇹🇼', name: 'Китайский (традиц.)', native: '繁體中文' },
  { code: 'zh-HK', flag: '🇭🇰', name: 'Кантонский', native: '粵語' },
  { code: 'ja',    flag: '🇯🇵', name: 'Японский', native: '日本語' },
  { code: 'ko',    flag: '🇰🇷', name: 'Корейский', native: '한국어' },
  { code: 'th',    flag: '🇹🇭', name: 'Тайский', native: 'ไทย' },
  { code: 'vi',    flag: '🇻🇳', name: 'Вьетнамский', native: 'Tiếng Việt' },
  { code: 'id',    flag: '🇮🇩', name: 'Индонезийский', native: 'Bahasa Indonesia' },
  { code: 'ms',    flag: '🇲🇾', name: 'Малайский', native: 'Bahasa Melayu' },
  { code: 'tl',    flag: '🇵🇭', name: 'Тагальский', native: 'Tagalog' },
];

export const DEFAULT_TRANSCRIPTION_LANGUAGE = 'ru';

export const findLanguage = (code) =>
  TRANSCRIPTION_LANGUAGES.find((l) => l.code === code) || TRANSCRIPTION_LANGUAGES[1]; // fallback ru
